<!-- 首页 -->
<template>
    <div class='container' style="padding:10px;">
        <el-row :gutter="20">
            <el-col :span="8">
                <el-card class="box-card">
                    <!-- 项目信息 -->
                    <div class="project-box">
                        <img :src="Default" alt="">
                        <div class="project-info">
                            <span class="title">{{projectsystemInfo.project_system_name}}</span>
                          <!--  <span class="address">{{`${projectsystemInfo.city}${projectsystemInfo.dist}${projectsystemInfo.address}`}}</span> -->
                            <span>{{projectsystemInfo.create_date}}</span>
                        </div>
                    </div>
                </el-card>
            </el-col>
            <el-col :span="16">
                <!-- 设备信息 -->
                <el-card class="box-card">
                    <div class="device-box">
                        <el-row :gutter="25">
                            <el-col :span="6">
                                <div class="device-item">
                                    <p class="num">设备总数</p>
                                    <div>{{data.terminalSum}}</div>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="device-item">
                                    <router-link to="/devicefault">
                                        <p class="denger">设备故障</p>
                                        <div>{{data.terminalErrorSum}}</div>
                                    </router-link>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="device-item">
                                    <p class="offline">设备离线</p>
                                    <div>{{data.terminalOfflineSum}}</div>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="device-item">
                                    <p class="poweroff">设备关机</p>
                                    <div>{{data.terminalPowerOffSum}}</div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </el-col>
            
        </el-row>
        <el-row :gutter="20"  style="margin-top:20px;">
            <el-col :span="8">
                <!-- 集控器统计 -->
                <el-card class="box-card">
                    <div id="main" class="main" ref="myEchart" style="width: 100%;"></div>
                </el-card>
            </el-col>
            <el-col :span="16">
                <!-- 故障列表 -->
                <el-card class="box-card">
                    <div class="fault_list" ref="fault_list">
                        <div class="fault_list-header">
                            <span class="c1">序列号</span>
                            <span class="c2">型号</span>
                            <span class="c3">位置</span>
                            <span class="c4">状态</span>
                            <span class="c5">故障时间</span>
                        </div>
                         <template v-if="errorData.length>0">
                            <i-marquee :interval="2000" :duration="300">
                                <li v-for="(v, i) in errorData" class="fault_item" :key="i">
                                    <span class="c1">{{v.terminal_serial}}</span>
                                    <span class="c2">{{v.device_model}}</span>
                                    <span class="c3">{{fmtHouseInfo(v.housename, v.moduleidlist)}}</span>
                                    <span class="c4">{{v.fault_type}}</span>
                                    <span class="c5">{{v.fault_data}}</span>
                                </li>
                            </i-marquee>
                        </template>
                        <template v-else>
                            <div style="padding:50px 0;font-size:14px;color:#ccc;text-align:center;">-- 暂无故障设备 --</div>
                        </template>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import Service from '@/api/Service'
import echarts from "echarts"
import IMarquee from '@/components/IMarquee/IMarquee'
import { fmtHouseInfo } from '@/utils/utils'
import Default from '@/assets/images/project_default.png'

export default {
    name:  'home',
    data() {
        return {
            data: {},
            errorData: [],
            chart: null,
        };
    },
    computed: { 
        // 项目，项目列表
        ...mapGetters(['projectInfo','projectsystemInfo']),
		
        Default() {
            return this.projectInfo.icon ? this.projectInfo.icon : Default
        },
    },
    components: { IMarquee },
    created() {
		// console.log(this.projectsystemInfo)
        this.getData();
        this.$nextTick(() => {
            let height =document.getElementsByClassName("wrapper-box")[0].offsetHeight - document.getElementsByClassName("breadcrumb-box")[0].offsetHeight - 332;
            document.getElementsByClassName("fault_list")[0].style.height = height + "px"
            document.getElementsByClassName("main")[0].style.height = height + "px"
        })
    },
    beforeDestroy() {
        if (!this.chart) {
            return;
        }
        this.chart.dispose();
        this.chart = null;
    },
    methods: {
        fmtHouseInfo,
        async getData() {
            let res = await Service.getStatistic();
            if(res) {
                this.data = res;
                if(res.terminalErrorData !== null && res.terminalErrorData.length>0) {
                    this.errorData = res.terminalErrorData;
                }
                let collector = [
                    {
                        value: res.collectorOnlineSum  || 0,
                        name: '在线',
                    },
                    {
                        value: res.collectorOfflineSum || 0 ,
                        name: '离线'
                    },
                ]
                this.chartConfig(collector)
            }
            
        },
        chartConfig(collector) {
            let _t = this;
            let myChart = echarts.init(this.$refs.myEchart); //这里是为了获得容器所在位置    
            window.onresize = myChart.resize;
            myChart.setOption({ // 进行相关配置
                title: {
                    text: '集控器状态',
                    left: 'center'
                },
                tooltip : {
                    trigger: 'item',
                    formatter: "{a} <br/>{b} : {c} ({d}%)"
                },
                legend: {
                    bottom: 10,
                    left: 'center',
                    data: ['离线', '在线',]
                },
                
                series : [
                    {
                        type: 'pie',
                        radius : '65%',
                        center: ['50%', '50%'],
                        selectedMode: 'single',
                        label: {
                            normal: {
                                formatter: function(data) {
                                    let str = `${data.data.name}：${data.data.value}`
                                    return str
                                },
                                position: 'inner'
                            }
                        },
                        data: collector,
                        itemStyle: {
                            emphasis: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            })
            myChart.on('click',{seriesType: "pie"}, function (params) {
                _t.$router.push('/gateway')
            });
        }
    },
}

</script>
<style lang='less' scoped>
    .project-box{
        display: -ms-flexbox;
        display: flex;
        -ms-flex-align: center;
        align-items: center;
        img{
            width: 100px;
            height: 100px;
            padding: 20px;
            // border-radius: 50%;
            display: block;
        }
        .project-info{
            padding-left: 30px;
            -ms-flex: 1;
            flex: 1;
            font-size: 14px;
            color: #999;
            overflow: hidden;
            span{
                display: block;
                height: 24px;
                line-height: 24px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                &.title{
                    font-size: 20px;
                    color: #222;
                    margin-bottom: 5px;
                }
                &.address{
                    height: 36px;
                    text-overflow: initial;
                    white-space: normal;
                    line-height: 18px;
                }
            }
        }
    }
    .device-box{
        .device-item{
            box-shadow: 0 0 2px #ccc;
            border-radius: 3px;
            transition: all .2s;
            &:hover{
                cursor: pointer;
                box-shadow: 0 0 6px #ccc;
            }
            a{
                text-decoration: none;
                color: inherit;
            }
            p{
                font-size: 14px;
                padding: 10px 0;
                color: #fff;
                line-height: 28px;
                text-align: center;
                border-bottom: 1px solid #ccc;
                &.num{
                    background-color: #2d8cf0;
                }
                &.denger{
                    background-color: #F56C6C;
                }
                &.online{
                    background-color: #2d8cf0;
                }
                &.offline{
                    background-color: #E6A23C;
                }
                &.poweron{
                    background-color: #2d8cf0;
                }
                &.poweroff{
                    background-color: #E6A23C;
                }
            }
            div{
                box-sizing: content-box;
                font-size: 42px;
                line-height: 68px;
                border: 1px solid #ccc;
                border-top: 0;
                padding: 10px 0;
                text-align: center;
            }
        }
    }
    .fault_list{
        .fault_list-header{
            height: 40px;
            line-height: 40px;
            width: 100%;
            font-size: 0;
            border-bottom: 1px solid #ccc;
            span{
                display: inline-block;
                font-size: 14px;
                color: #333;
                font-weight: bold;
                vertical-align: middle;
                text-align: center;
            }
        }
    }
</style>
<style lang="less">
.fault_list{
    .fault_item{
        width: 100%;
        font-size: 0;
        span{
            display: inline-block;
            font-size: 12px;
            vertical-align: middle;
            text-align: center;
            overflow: hidden;
        }
    }
    .c1{
        width: 10%;
    }
    .c2{
        width: 10%;
    }
    .c3{
        width: 40%;
    }
    .c4{
        width: 10%;
    }
    .c5{
        width: 30%;
    }
}
</style>